import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createProduct } from 'redux/product'
import ProductEdit from './ProductEdit'

const mapStateToProps = (state, ownProps) => {
  const { importProduct } = state.product
  return { importProduct }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      createProduct,
    },
    dispatch
  )
}

class ProductImport extends React.Component {
  render() {
    const { importProduct } = this.props
    const { createProduct } = this.props
    return (
      <ProductEdit
        kind="import"
        product={{ ...importProduct, kind: 'import' }}
        onSave={createProduct}
        form={'product_import_form'}
        tabs={['generic', 'properties', 'media', 'todos']}
      />
    )
  }
}

ProductImport = connect(mapStateToProps, mapDispatchToProps)(ProductImport)
export default ProductImport



// WEBPACK FOOTER //
// ./src/components/admin/Products/ProductImport.jsx